import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export const DEFAULT_AGREEMENT_STATUS = {
    in: [
        'active',
        'exhausted'
    ]
};
const groupArms = (filter)=>{
    var _ref, _filter_and;
    return (_ref = (_filter_and = filter.and) !== null && _filter_and !== void 0 ? _filter_and : filter.or) !== null && _ref !== void 0 ? _ref : [];
};
const statusIsAlreadyNarrowed = (filter)=>filter.status != null || groupArms(filter).some((arm)=>arm.status != null);
export const withDefaultAgreementStatus = (filter)=>statusIsAlreadyNarrowed(filter) ? filter : _object_spread_props(_object_spread({}, filter), {
        status: DEFAULT_AGREEMENT_STATUS
    });
export const DEFAULT_AGREEMENT_FILTER = withDefaultAgreementStatus({
    version: '1'
});
const isDefaultStatus = (status)=>{
    var _DEFAULT_AGREEMENT_STATUS_in;
    const defaults = (_DEFAULT_AGREEMENT_STATUS_in = DEFAULT_AGREEMENT_STATUS.in) !== null && _DEFAULT_AGREEMENT_STATUS_in !== void 0 ? _DEFAULT_AGREEMENT_STATUS_in : [];
    return status.nin == null && status.in != null && status.in.length === defaults.length && defaults.every((value)=>{
        var _status_in;
        return ((_status_in = status.in) === null || _status_in === void 0 ? void 0 : _status_in.includes(value)) === true;
    });
};
export const isDefaultAgreementFilter = (filter)=>{
    if (filter == null) return true;
    const hasAnotherField = Object.entries(filter).some((param)=>{
        let [field, value] = param;
        return field !== 'version' && field !== 'status' && value != null;
    });
    if (hasAnotherField) return false;
    return filter.status == null || isDefaultStatus(filter.status);
};
